var Color;
(function (Color) {
    Color["Black"] = "#000000";
    Color["BlackOpacity45"] = "rgba(0, 0, 0, 0.45)";
    Color["BlackOpacity57"] = "rgba(0, 0, 0, 0.57)";
    Color["BlackOpacity30"] = "rgba(0, 0, 0, 0.3)";
    Color["ForestGreen"] = "#358f20";
    Color["Apple"] = "#43b02a";
    Color["VidaLoca"] = "#4e8e1d";
    Color["Atlantis"] = "#50d332";
    Color["GreenHaze"] = "#009a44";
    Color["GreenHazeOpacity80"] = "rgba(0, 154, 68, .8)";
    Color["FunGreen"] = "#007b36";
    Color["ElectricBlue"] = "#004a9b";
    Color["CobaltBlue"] = "#0054af";
    Color["OceanBlue"] = "#0091da";
    Color["MicrosoftBlue"] = "#009ceb";
    Color["MicrosoftBlueOpacity8"] = "rgba(0, 156, 235, .08)";
    Color["DarkCyanBlue"] = "#00a4d3";
    Color["DarkCyanBlueOpacity80"] = "rgba(0, 164, 211, .8)";
    Color["DeepCerulian"] = "#0083a8";
    Color["TuftsBlue"] = "#478ddb";
    Color["JordyBlue"] = "#83b9ec";
    Color["HawkesBlue"] = "#f2f8fe";
    Color["DodgerBlue"] = "#28c5ff";
    Color["DodgerBlueOpacity80"] = "rgba(40, 197, 255, .8)";
    Color["DarkSkyBlue"] = "#208bda";
    Color["DarkSkyBlueOpacity80"] = "rgba(32, 139, 218, .8)";
    Color["FunBlue"] = "#196fae";
    Color["Smalt"] = "#00338D";
    Color["SmaltOpacity80"] = "rgba(0, 51, 141, .8)";
    Color["MidnightBlue"] = "#002870";
    Color["OldGold"] = "#eaaa00";
    Color["GoldenTainoi"] = "#ffcc66";
    Color["Koromiko"] = "#feb46c";
    Color["FlushOrange"] = "#ff7f00";
    Color["RedStage"] = "#d16800";
    Color["AthensGrey"] = "#f0f2f5";
    Color["Grey85"] = "#555555";
    Color["Grey172"] = "#acacac";
    Color["Grey172Opacity45"] = "rgba(172, 172, 172, 0.45)";
    Color["Grey187"] = "#bbbbbb";
    Color["Grey223"] = "#dfdfdf";
    Color["Grey254"] = "#fefefe";
    Color["Grey163"] = "#a3a3a3";
    Color["Grey217"] = "#d9d9d9";
    Color["Selago"] = "#f4f8fe";
    Color["White"] = "#ffffff";
    Color["Red"] = "#ff0000";
    Color["RedOpacity80"] = "rgba(255, 0, 0, 0.8)";
    Color["GuardsmanRed"] = "#cc0000";
    Color["SunsetOrange"] = "#ff4d4f";
    Color["SunsetOrangeOpacity8"] = "rgba(255, 77, 79, 0.08)";
    Color["Rose"] = "#e00744";
    Color["RoseOpacity80"] = "rgba(224, 7, 68, .8)";
    Color["Shiraz"] = "#b30536";
    Color["MaroonFlush"] = "#bc204b";
    Color["MaroonFlushOpacity80"] = "rgba(188, 32, 75, .8)";
    Color["Claret"] = "#96193c";
    Color["WebOrange"] = "#eaaa00";
    Color["WebOrangeOpacity80"] = "rgba(234, 170, 0, .8)";
    Color["PirateGold"] = "#bb8800";
    Color["ChelseaGem"] = "#987101";
    Color["ChelseaGemOpacity80"] = "rgba(152, 113, 1, .8)";
    Color["Cinnamon"] = "#795a00";
    Color["Seance"] = "#aa20ba";
    Color["SeanceOpacity80"] = "rgba(170, 32, 186, .8)";
    Color["ChinesePurple"] = "#55105d";
    Color["CuriousBlue"] = "#198dda";
    Color["CuriousBlueOpacity80"] = "rgba(25, 141, 218, .8)";
    Color["DeepSeaGreen"] = "#0c466d";
})(Color || (Color = {}));
export default Color;
